export default __webpack_public_path__ + "static/media/event.af90fb93.png";